module.exports = "/_next/static/images/prateekb-1f91b49e935d705eb803117d7af839ae.png";